export enum LabelType {
  OUTLINE = 'outline',
  SOLID = 'solid'
}

export interface CustomLabelCss {
  [key: string]: string;
}
